<template>
  <SelectContianer
    v-on:closeSelectContainer="close"
    :showChildSelect="showChildSelector"
    :isShowClose="true"
  >
    <template slot="select-header">
      <div class="product-popup-header flex-between">
        <div class="product-popup-title">{{ letter.storeProductDetail }}</div>
      </div>
    </template>
    <template slot="select-content">
      <div class="product-popup-content">
        <div class="product-popup-content-scroll">
          <div
            class="product-item"
            v-for="(item, index) in productList"
            :key="index"
          >
            <img
              class="product-icon"
              v-if="getGameIcon(item.ICON, item.TRANS_AMOUNT)"
              :src="getGameIcon(item.ICON, item.TRANS_AMOUNT)"
              alt="icon"
            />
            <div class="product-info">
              <span>{{ item.NAME }}*{{ item.COUNT }}</span
              ><span v-if="item.isExtra" class="extra-gift"
                >({{ letter.v3ExtraGift }})</span
              ><span v-if="item.isProductDoubleExtra" class="extra-gift"
                >({{ letter.v3FirstTopUpGiveaway }})</span
              >
            </div>
          </div>
        </div>
        <div class="product-popup-btn-wrap flex-center" v-if="showBtn">
          <div
            class="product-btn"
            v-if="openShoppingCart"
            @click="addProductToCart"
          >
            <span>{{ product.GAME_AMOUNT }} {{ showCurrency }} </span>
            <Icon class="cart" name="shopping-cart-add"></Icon>
          </div>
          <div v-else class="product-btn" @click.stop="selectProduct">
            <span>{{ product.GAME_AMOUNT }} {{ showCurrency }}</span>
            <Icon class="cart" name="shopping-cart-add"></Icon>
          </div>
        </div>
      </div>
    </template>
  </SelectContianer>
</template>

<script>
import { mapMutations, mapState, mapGetters } from 'vuex';
import {
  clickButton,
  locationType,
  showPopup
} from '@plugins/biPoint/_configWebstoreV35';
import selectContainer from '@mixins/officialTopupNew/selectContainer';
import icon from '@mixins/officialTopupNew/icon';
import cartAddAndDetail from '@mixins/officialTopupNew/cartAddAndDetail';
import extra from '@mixins/officialTopupNew/extra';
export default {
  name: 'ProductDetailPopup',
  mixins: [selectContainer, icon, cartAddAndDetail, extra],
  props: {
    showChildSelector: {
      type: Boolean,
      default: false
    },
    product: {
      type: Object,
      default: () => ({})
    },
    showBtn: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {};
  },
  computed: {
    ...mapState({
      letter: state => state.letter,
      lang: state => state.lang,
      showCurrency: state => state.showCurrency,
      openShoppingCart: state => state.page.openShoppingCart
    }),
    productList() {
      let amountLevelExtra = this.product?.amountLevel?.EXTRA_COIN;
      const extraItem = {
        ID: new Date().getTime(),
        COUNT: amountLevelExtra,
        NAME: this.showExtraName,
        ICON: this.showExtraIcon,
        TRANS_AMOUNT: amountLevelExtra,
        isExtra: true
      };
      let list = [];
      if (this.product?.CP_PRODUCT_EXT?.CONTENT?.length) {
        list.push(...this.product?.CP_PRODUCT_EXT?.CONTENT);
      } else {
        list.push({
          NAME: this.product?.CP_PRODUCT_DESC || this.product?.PRODUCT_DESC,
          COUNT: 1,
          ICON: this.product?.PRODUCT_ICON,
          TRANS_AMOUNT: this.product?.TRANS_AMOUNT
        });
      }
      // 配置了加码图标，才显示
      if (this.showExtraIcon) {
        const productExtraCoin = this?.product?.PRODUCT_EXTRA_COIN;
        // 首充优惠
        if (productExtraCoin && +productExtraCoin > 0) {
          list.push({
            ID: new Date().getTime(),
            COUNT: productExtraCoin,
            NAME: this.showProductExtraCoinName,
            ICON: this.showProductExtraCoinIcon,
            TRANS_AMOUNT: productExtraCoin,
            isProductDoubleExtra: true
          });
        }
        // 商品加码
        if (+amountLevelExtra > 0) {
          list.push(extraItem);
        }
      }
      return list;
    }
  },
  mounted() {
    showPopup(locationType.productDetailPopup);
  },
  methods: {
    addProductToCart() {
      clickButton({
        btnName: 'add_to_cart',
        locationKey: locationType.selectProduct
      });
      this.$emit('clickAddToCart', this.product);
      this.close();
    },
    selectProduct() {
      clickButton({
        btnName: 'select_product',
        locationKey: locationType.selectProduct
      });
      this.$emit('selectProduct', this.product);
      this.close();
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialTopupNew/_dimen.scss';
@import '@assets/scss/officialTopupNew/officialTopupNew.scss';

.product-popup {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 8;
  width: 100%;
  height: 100%;

  &-header {
    width: 100%;
  }

  &-title {
    width: 100%;
    color: #333333;
    font-size: 28px;
    font-weight: bold;
  }
  &-content {
    box-sizing: border-box;
    width: 100%;
    height: calc(100% - 20px);
    font-size: 22px;
    &-scroll {
      height: 720px;
      overflow-y: scroll;
      position: relative;
      max-height: 70%;
      padding: 0 7px;
      margin-top: 20px;
    }
  }

  &-btn-wrap {
    box-sizing: border-box;
    position: absolute;
    bottom: 30px;
    left: 50%;
    transform: translateX(-50%);
    margin: 30px auto;
    width: 100%;
    padding: 0 40px;
    height: 70px;

    .product-btn {
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      height: 70px;
      padding: 0 20px;
      background: linear-gradient(
        348deg,
        $buttonGradientColor1,
        $buttonGradientColor2
      );
      border-radius: 10px;
      font-size: 30px;
      font-weight: bold;
      color: #ffffff;
      cursor: pointer;

      .cart {
        width: 45px;
        height: 40px;
      }
    }
  }
}

.product-item {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding: 20px 30px;
  width: 100%;
  background-color: #ffffff;
  border-radius: 20px;
  margin-bottom: 10px;
  .product-icon {
    flex-shrink: 0;
    width: 95px;
    height: 95px;
    margin-right: 20px;
  }
  .extra-gift {
    color: red;
    margin-left: 10px;
  }
}

#ssr-page.landscape {
  .product-popup {
    &-header {
      text-align: center;
      padding-left: 40px;
    }
    &-content {
      box-sizing: border-box;
      height: fit-content;
      &-scroll {
        overflow-y: scroll;
        margin-top: 22px;
        height: 370px;
      }
    }
    &-btn-wrap {
      position: relative;
      bottom: 0;
      margin: 30px auto;
      padding: 0;
      height: 60px;
      box-sizing: border-box;
    }
    &-title {
      line-height: 1.2;
      font-size: 22px;
    }
  }
  .product-item {
    display: flex;
    align-items: center;
    .product-icon {
      width: 66px;
      height: 66px;
    }
  }
}

@media only screen and (min-height: 640px) and (orientation: landscape) {
  .product-content-scroll {
    height: 391px;
  }
}

/* iPad纵向方向样式 */
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
  .product-content-scroll {
    height: 500px;
  }
}
</style>
